import { Outlet, createFileRoute } from '@tanstack/react-router';
import { DarkModeToggle } from '@/components/shared/dark-mode-toggle';
import { SmartBanner } from '@/components/common';

export const Route = createFileRoute('/(consumer)/_auth-layout')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <SmartBanner role="customer" />
      <div className="bg-muted relative hidden lg:block">
        <img
          src="/images/sign_img.png"
          alt="Image"
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover dark:brightness-[0.2] dark:grayscale"
        />
      </div>
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex justify-end">
          <DarkModeToggle variant="icon" />
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-sm">
            <a
              href="#"
              className="flex items-center justify-center gap-2 font-medium mb-10"
            >
              <img
                src="/images/logo.png"
                alt="Logo"
                className="h-20 w-auto mb-2"
              />
            </a>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
